import { SvgIcon } from '@mui/material';
import { ReactComponent as ArrowCardSvg } from '../../../../assests/images/help/arrowCardHelp.svg';

// Flecha de las cards. Va inline solo para controlar el tamaño con `fontSize`:
// el color lo trae el propio asset.
const ArrowCardIcon = (props) => (
  <SvgIcon {...props} component={ArrowCardSvg} inheritViewBox />
);

export default ArrowCardIcon;
